import {
  Tab as ReachTab,
  TabList as ReachTabList,
  TabPanels,
  Tabs as ReachTabs,
} from '@reach/tabs';
import '@reach/tabs/styles.css';
import { Button } from 'components/ui';
import { Children, FC, ReactElement } from 'react';
import styled from 'styled-components';
import { TabProps } from './tab';

type ChildType = ReactElement<TabProps>;

export interface TabsProps {
  children: ChildType[] | ChildType;
}

const TabList: any = styled(ReachTabList)`
  flex-wrap: wrap;
  margin-bottom: var(--space-3);
  background-color: transparent;

  > * + * {
    margin-left: var(--space-1);
  }

  @supports (gap: 1px) {
    gap: var(--space-1);

    > * {
      margin-left: 0;
    }
  }
`;

export const Tabs: FC<TabsProps> = ({ children }) => {
  const titles = Children.map(
    children,
    (child: ChildType) => child.props.title
  );

  return (
    <ReachTabs>
      <TabList>
        {titles.map((title) => (
          <ReachTab key={title} as={Button}>
            {title}
          </ReachTab>
        ))}
      </TabList>
      <TabPanels>{children}</TabPanels>
    </ReachTabs>
  );
};
